<template>
  <v-container>
    <a href="#images">Images</a>
    <br />
    <a href="#terms">Terms</a>
    <div>
      <div class="display-1 blue--text" id="images">Images</div>
        <v-card outlined flat class="pa-5">
          <v-layout class="pa-3" row wrap v-for="(item, key) in images" :key="key">
            <v-flex xs12 class="grey--text">
              {{key}}
            </v-flex>
            <v-flex xs5 class="pa-3">
              <img style="width: 100%" :src="item.image"/>
            </v-flex>
            <v-flex xs3>
              {{item.term}}
            </v-flex>
            <v-flex xs4>
              {{item.description}}
            </v-flex>
          </v-layout>

        </v-card>
      </div>

      <div class="display-1 blue--text" id="terms">Terms</div>
        <v-card outlined flat class="pa-5">
          <v-layout class="pa-3" row wrap v-for="(item, key) in terms" :key="key">
            <v-flex xs12 class="grey--text">
              {{key}}
            </v-flex>
            <v-flex xs3>
              {{item.term}}
            </v-flex>
            <v-flex xs6>
              {{item.description}}
            </v-flex>
          </v-layout>

        </v-card>
      </div>

    </div>
  </v-container>
</template>
<script>
import Images from '@/content/image_db_dict_2.json'
import Terms from '@/content/term_db_dict.json'

export default {
  name: 'ContentReview',
  data() {
    return {
      images: Images,
      terms: Terms
    }
  },

}
</script>
